/**
 * Created by PhpStorm.
 * User: i.sollima
 * Contact: i.sollima@accenture.com
 * Date: 16/07/2019
 * Time: 12:09
 */

function Fetch(config) {

    const _config = {
        uri: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        data: false,
        timeout: 60000,
        method: 'GET',
    };

    if (typeof (config) === "string") {
        config = {uri: config}
    }
    config = extend(_config, config);


    function init(config) {

        return new Promise((resolve, _) => {
            resolve(drupalSettings.authTokenBE);
        }).then((token) => {

            let {uri, method, headers, data} = config;
            if (uri){
                let body;
                if(method === 'POST') {
                    body = JSON.stringify(data);
                } else {
                    let keys = '';
                    for (let key in data){
                        if(data.hasOwnProperty(key)){
                            const val = data[key];
                            keys += `${key}=${val}&`;
                        }
                    }
                    if(keys){
                        uri =  `${uri}?${keys.slice(0, -1)}`;
                    }
                }
                return timeout(config.timeout, fetch(uri, {
                    headers: {
                        ...headers,
                        "X-CSRF-Token": token,
                    },
                    method: method,
                    body,
                }));
            }
        })

    }

    return init(config);

    // Rough implementation. Untested.
    function timeout(ms, promise) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(new Error("Timeout"))
            }, ms);
            promise.then(resolve, reject);
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error(`${response.status} - ${response.statusText || "No message from server."}`)
            }
        })
    }
}
initializeUtilsFunctions();
publish(Fetch, "Fetch");
